import { put, takeEvery } from 'redux-saga/effects';
import {
  startFetchSmsUserTemplate,
  fetchTemplateSuccess,
  fetchTemplateFailure,
} from 'redux/template/actions';
import { Notify } from '@flexisaf/flexibull2';
import request from 'utils/request';
import urls from 'utils/config';
import TemplatesActionTypes from '../types';
import { networkErrorHandler } from 'utils/errrorHandlers';


const { TEMPLATE_BASE_URL } = urls || {};

export function* fetchUserSmsTemplates({ payload }) {
  const url = `${TEMPLATE_BASE_URL}/templates?type=sms&index=${
    +payload.currentPage || 0
  }&size=${+payload.pageSize || 10}${
    payload.searchPattern ? `&name=${payload.searchPattern}` : ''
  }`;

  const response = yield request({
    method: 'get',
    url,
  });
  if (response.success) {
    yield put(
      fetchTemplateSuccess({
        template: response.raw,
        type: 'sms',
        explicitType: 'user',
      })
    );
  } else {
    networkErrorHandler(response?.statusCode, `Failed to Fetch Templates: ${response.message}`);

    yield put(fetchTemplateFailure(response.message));
  }
}

export function* getSmsUserTemplates() {
  yield takeEvery(
    TemplatesActionTypes.START_FETCH_SMS_USER_TEMPLATES,
    fetchUserSmsTemplates
  );
}

export function* fetchSystemSmsTemplates({ payload }) {
  const url = `${TEMPLATE_BASE_URL}/admin?type=sms&index=${
    +payload.currentPage || 0
  }&size=${+payload.pageSize || 10}`;

  const response = yield request({
    method: 'get',
    url,
  });
  if (response.success) {
    yield put(
      fetchTemplateSuccess({
        template: response.raw,
        type: 'sms',
        explicitType: 'system',
      })
    );
  } else {
    networkErrorHandler(response?.statusCode, `Failed to Fetch Templates: ${response.message}`);
    yield put(fetchTemplateFailure(response.message));
  }
}

export function* getSmsSystemTemplates() {
  yield takeEvery(
    TemplatesActionTypes.START_FETCH_SMS_SYSTEM_TEMPLATES,
    fetchSystemSmsTemplates
  );
}

export function* updateUserSmsTemplates({ payload }) {
  const { id, active } = payload;
  const url = `${TEMPLATE_BASE_URL}/templates/${id}`;

  const response = yield request({
    method: 'patch',
    data: {
      active,
    },
    url,
  });
  if (response.success) {
    yield put(
      startFetchSmsUserTemplate({
        currentPage: 0,
        pageSize: 10,
      })
    );
    Notify('Template updated successfully', {
      position: 'top-right',
      status: 'success',
    });
  } else {
    networkErrorHandler(response?.statusCode, `Failed to Update Templates: ${response.message}`);

    yield put(fetchTemplateFailure(response.message));
  }
}

export function* onUpdateSmsUserTemplates() {
  yield takeEvery(
    TemplatesActionTypes.UPDATE_SMS_TEMPLATE_START,
    updateUserSmsTemplates
  );
}
